module.exports = __webpack_public_path__ + "img/list_default5.05095f34.png";